/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'goal-fields.goal-followers.add-followers-title': 'Add followers',
  'goal-fields.goal-followers.title': 'Followers',
  'goal-fields.goal-links.add-parent-goal-title': 'Add a parent goal',
  'goal-fields.goal-links.edit-parent-goal-title': 'Edit parent goal',
  'goal-fields.goal-links.unlink-parent-goal-title': 'Unlink parent goal',
  'goal-fields.goal-metrics.automatic-metric-title': 'From sub-goals',
  'goal-fields.goal-metrics.manual-metrics-popup-content.start-value-label': 'Start:',
  'goal-fields.goal-metrics.manual-metrics-popup-content.target-value-label': 'Target:',
  'goal-fields.goal-metrics.metrics-popup.external-metric-description':
    'Progress is auto-populated via {compass}. This goal metric can only be edited in {compass}.',
  'goal-fields.goal-metrics.no-metrics-instructions': 'Go to the full goal page to change this field',
  'goal-fields.goal-metrics.no-metrics-title': 'No metric',
  'goal-fields.goal-metrics.percentage-metric-completion-percentage.description': 'progress made',
  'goal-fields.goal-metrics.rollup-metric-title-no-sub-goals': 'No sub-goals with metrics connected',
  'goal-fields.goal-metrics.title': 'Progress',
  'goal-fields.goal-owner.title': 'Owner',
  'goal-fields.goal-start-date.add-start-date-title': 'Add start date',
  'goal-fields.goal-start-date.cancel-button': 'Save',
  'goal-fields.goal-start-date.creation-date': 'This goal was created on {creationDate}',
  'goal-fields.goal-start-date.edit-start-date-label': 'Edit goal start date',
  'goal-fields.goal-start-date.enter-start-date-title': 'Enter start date',
  'goal-fields.goal-start-date.open-calendar-label': 'Open calendar',
  'goal-fields.goal-start-date.title': 'Start date',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-in-progress': 'In progress',
  'goal-fields.goal-status-picker.goal-status-lifecycle-picker-more-button': 'More statuses',
  'goal-fields.goal-status-picker.goal-status-okr-current-status': 'What is the current status?',
  'goal-fields.goal-status-picker.goal-status-okr-help-content':
    'Practice Objectives and Key Results? <link>See how to use goals for OKRs</link>',
  'goal-fields.goal-status-picker.goal-status-okr-help-info-icon-label': 'Help link',
  'goal-fields.goal-status.archived': 'Archived',
  'goal-fields.goal-status.at-risk': 'At risk',
  'goal-fields.goal-status.cancelled': 'Canceled',
  'goal-fields.goal-status.completed': 'Completed 🎉',
  'goal-fields.goal-status.edit-status-lozenge': 'Edit status',
  'goal-fields.goal-status.off-track': 'Off track',
  'goal-fields.goal-status.on-track': 'On track',
  'goal-fields.goal-status.paused': 'Paused',
  'goal-fields.goal-status.pending': 'Pending',
  'goal-fields.goal-status.title': 'Status',
  'goal-fields.goal-sub-goals.add-sub-goals-title': 'Add sub goals',
  'goal-fields.goal-sub-goals.unlink-sub-goal-tooltip': 'Unlink sub goal',
  'goal-fields.goal-tags.add-tags-title': 'Add tags',
  'goal-fields.goal-tags.title': 'Tags',
  'goal-fields.goal-target-date.title': 'Target date',
  'goal-fields.goal-type.goal': 'Goal',
  'goal-fields.goal-type.key-result': 'Key result',
  'goal-fields.goal-type.objective': 'Objective',
  'goal-fields.goal-type.title': 'Type',
  'goal-fields.parent-goal.title': 'Parent goal',
  'goal-fields.sub-goals.title': 'Sub-goals',
  'goal-fields.teams.add-teams-title': 'Add teams',
  'goal-fields.teams.follow-team': 'Follow team',
  'goal-fields.teams.remove-team': 'Remove team',
  'goal-fields.teams.search-team-placeholder': 'Search team',
  'goal-fields.teams.show-more': 'Show more',
  'goal-fields.teams.title': 'Teams',
  'goal-fields.teams.verified-team-label': 'Verified team',
  'goal-fields.teams.view-profile': 'View profile',
  'goal-fields.use-goal-flags.generic-error-description': 'Something went wrong, try again in a few minutes.',
  'goal-fields.use-goal-flags.generic-error-title': 'Something went wrong',
  'goal-fields.use-goal-flags.goal-owner-change-error-header': 'Could not change goal owner',
  'goal-fields.use-goal-flags.goal-tags-add-failure-title': "Tag couldn't be added",
  'goal-fields.use-goal-flags.goal-tags-create-failure-title': "Tag couldn't be created",
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-description':
    'The tag name you entered is too long. Please enter a tag name with 255 characters or fewer.',
  'goal-fields.use-goal-flags.goal-tags-create-limit-failure-title': 'Tag couldn’t be created',
  'goal-fields.use-goal-flags.goal-tags-remove-failure-title': "Tag couldn't be removed",
  'goal-fields.use-goal-flags.goal-teams-add-failure-title': 'Error adding team, please try again',
  'goal-fields.use-goal-flags.goal-teams-remove-failure-title': 'Error removing team, please try again',
  'goal-fields.use-goal-flags.parent-goal-change-error-header': 'Could not change parent goal',
  'goal-fields.use-goal-flags.start-date-change-error-header': 'Could not change start date',
  'goal-fields.use-goal-flags.target-date-change-error-header': 'Could not change target date',
  'townsquare.goal-fields.tag': 'Remove tag',
  'townsquare.goal-fields.tooltip-usage-count': 'Used in {usageCount, plural, one {# place} other {# places}}',
};
